module.exports = __webpack_public_path__ + "img/scope3category11.6976e797.svg";